import { Component, OnInit } from '@angular/core';

import { Observable } from 'rxjs';

import { Toast } from '@stylehaven/components';

import { BootstrapSandboxService } from '@bootstrap/sandbox/bootstrap.sandbox.service';

@Component({
    standalone: false,
    selector: 'archive-mgmt-root',
    templateUrl: './root-container.component.html'
})
export class RootContainerComponent implements OnInit {
    toasts$!: Observable<Toast[]>;
    isTokenLoading$!: Observable<boolean>;

    constructor(private readonly sandbox: BootstrapSandboxService) {}

    ngOnInit(): void {
        this.setupLoadingStream();
        this.setupToastsStream();
    }

    deleteToastById(toastId: number): void {
        this.sandbox.deleteToast(toastId);
    }

    private setupLoadingStream(): void {
        this.isTokenLoading$ = this.sandbox.isTokenLoading$;
    }

    private setupToastsStream(): void {
        this.toasts$ = this.sandbox.toasts$;
    }
}
